import { ENotAuthNavigation } from '@hts/shared/enums';
import { Suspense, lazy } from 'react';
import { Navigate, Route } from 'react-router-dom';

const CardPage = lazy(() => import('@hts/pages/card/CardPage'));
const ResendCardPage = lazy(() => import('@hts/pages/card/ResendCardPage'));
const CategoryPage = lazy(() => import('@hts/pages/CategoryPage'));
const CustomCardItemPage = lazy(() => import('@hts/pages/CustomCardItemPage'));
const FormPage = lazy(() => import('@hts/pages/FormPage'));
const HomePage = lazy(() => import('@hts/pages/home/HomePage'));
const NotFoundPage = lazy(() => import('@hts/pages/notFound/NotFoundPage'));
const PrivacyPolicyPage = lazy(() => import('@hts/pages/PrivacyPolicyPage'));
const SearchPage = lazy(() => import('@hts/pages/SearchPage'));
const ThanksPage = lazy(() => import('@hts/pages/ThankgsPage'));

export const NotAuthNavigator = (
  <>
    <Route
      path={ENotAuthNavigation.MAIN}
      element={
        <Suspense>
          <HomePage isHome={true} />
        </Suspense>
      }
    />

    <Route
      path={`${ENotAuthNavigation.PAGES}/:page/`}
      element={
        <Suspense>
          <HomePage isHome={false} />
        </Suspense>
      }
    />

    <Route
      path={ENotAuthNavigation.ACCOUNT_LOGIN}
      element={
        <Suspense>
          <FormPage title="Account Login" form="login" />
        </Suspense>
      }
    />

    <Route
      path={ENotAuthNavigation.REGISTRATION}
      element={
        <Suspense>
          <FormPage title="Registration" form="register" />
        </Suspense>
      }
    />

    <Route
      path={ENotAuthNavigation.CONTACT_US}
      element={
        <Suspense>
          <FormPage title="Contact Us" form="contact" />
        </Suspense>
      }
    />

    <Route
      path={ENotAuthNavigation.LOST_PASSWORD}
      element={
        <Suspense>
          <FormPage title="Lost password" form="lost-password" />
        </Suspense>
      }
    />

    <Route
      path={ENotAuthNavigation.SEARCH}
      element={
        <Suspense>
          <SearchPage />
        </Suspense>
      }
    />

    <Route
      path={ENotAuthNavigation.ACCOUNT}
      element={
        <Suspense>
          <Navigate to="/account-login" />
        </Suspense>
      }
    />

    <Route
      path={`${ENotAuthNavigation.CATEGORY_OF_CARD}/:category/`}
      element={
        <Suspense>
          <CategoryPage />
        </Suspense>
      }
    />

    <Route
      path={`${ENotAuthNavigation.CARD}/:card/`}
      element={
        <Suspense>
          <CardPage />
        </Suspense>
      }
      key={window.location.pathname}
    />

    <Route
      path={`${ENotAuthNavigation.RESEND_CARD}`}
      element={
        <Suspense>
          <ResendCardPage />
        </Suspense>
      }
    />

    <Route
      path={`${ENotAuthNavigation.CUSTOM_CARD}/:customCard/`}
      key={window.location.pathname}
      element={
        <Suspense>
          <CustomCardItemPage />
        </Suspense>
      }
    />

    <Route
      path={ENotAuthNavigation.NOT_FOUND}
      element={
        <Suspense>
          <NotFoundPage />
        </Suspense>
      }
    />

    <Route
      path={ENotAuthNavigation.THANK_YOU}
      element={
        <Suspense>
          <ThanksPage />
        </Suspense>
      }
    />

    <Route
      path={ENotAuthNavigation.PRIVACY_POLICY}
      element={
        <Suspense>
          <PrivacyPolicyPage />
        </Suspense>
      }
    />

    <Route
      path="*"
      element={
        <Suspense>
          <NotFoundPage />
        </Suspense>
      }
    />
  </>
);
